var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input van-cell van-field"},[_c('input',{staticClass:"input",attrs:{"type":"text","maxlength":"11","onkeyup":"value=value.replace(/[^\\d]/g,'')"},domProps:{"value":_vm.value},on:{"input":_vm.input}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2659a40a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageInputTel.vue
// module id = null
// module chunks = 